import { makeStyles } from "@material-ui/core";
import { Colors } from "../../utils";

const makeClasses = makeStyles((theme) => ({
  dialog: {
    boxShadow: "none",
    width: "50%",
    maxWidth: "50%",
    minHeight: 500,

    [theme.breakpoints.down("sm")]: {
      width: "95%",
      maxWidth: "95%",
      margin: 0,
      minHeight: "50%",
    },
  },
  dialogTitleWrapper: {
    background: Colors.rgb.black_light,
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,

    "& > h2": {
      position: "relative",
      display: "flex",
      alignItems: "center",
    },
  },
  dialogTitle: {
    fontFamily: theme.fontFamily.light,
    fontSize: theme.fontSize.XL,
    color: Colors.rgb.white,

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      fontSize: theme.fontSize.M,
    },
  },
  dialogContentWrapper: {
    padding: theme.spacing(4),
    paddingTop: 0,
  },
  dialogContent: {
    fontFamily: theme.fontFamily.light,
    fontSize: theme.fontSize.L,
    color: Colors.rgb.contentText,

    "& strong": {
      fontFamily: theme.fontFamily.bold,
    },

    "& a": {
      color: Colors.rgb.primary,
    },
  },
  dialogActionsWrapper: {
    padding: `${theme.spacing(2)} 0`,
    margin: `0 ${theme.spacing(4)}`,
    borderTop: `1px solid ${Colors.rgb.contentLineSoft}`,

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(2),

      "& > div": {
        width: "100%",
        justifyContent: "center",
      },
    },
  },
  inputFileContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: theme.spacing(4),

    [theme.breakpoints.down("sm")]: {
      flexDirection: 'column'
    }
  },
  inputFile: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentText,
    fontSize: theme.fontSize.L,
    borderBottom: `1px solid ${Colors.rgb.contentLine}`,
    paddingBottom: 4,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: '35%',

    [theme.breakpoints.down("sm")]: {
      width: '100%'
    },

    "& > label": {
      position: "relative",
    },

    "& > label > div": {
      color: Colors.rgb.contentTextSoft,
      fontSize: theme.fontSize.S,
    },

    '& > input[type="file"]': {
      height: 0,
      position: "absolute",
    },
  },
  inputFileIcon: {
    position: "absolute",
    marginTop: 20,
    right: 0,
    top: 0,
  },
}));

export default makeClasses;
